<div class="homepage">
  <main id="main-content">
    <div class="homepage-content">
      <inexp-assistant-hero
        [title]="hero.title"
        [description]="hero.description"
        [searchPlaceholder]="hero.searchPlaceholder"
        [searchButtonText]="hero.searchButtonText"
      ></inexp-assistant-hero>
    </div>
  </main>
</div>
